module.exports = __webpack_public_path__ + "static/media/icon-bulb.0e011a5f.svg";